<template>
    <div style="height: 100vh" :style="{background:type==='0' ? '#F0F8FD' : '#F1F8F2'}">
        <div v-if="type === '0'">
              <van-search
                v-model="searchValue"
                shape="round"
                placeholder="公益组织"
                background="#F0F8FD"
                @search="onSearch">
              <template #right-icon>
                <div @click="onSearch">搜索</div>
              </template>
            </van-search>

              <van-swipe :autoplay="4000" style="width: 95%;margin: 5px 0px; height: 200px;position: relative;border-radius: 10px;left: 10px;">
                <van-swipe-item v-for="(item,index) in images" :key="index" @click="clickBanner(item)">
                  <van-image :src="item.imageUrl" width="100%" height="100%"/>
                </van-swipe-item>
              </van-swipe>

            <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                      @change="getProductListData" style="" class="first-cate" >
              <van-tab v-for="item1 in list" :key="item1.title" :title="item1.title" style="border-top: 1px solid #ebedf0;">
                <van-tabs v-model="active1" swipeable animated sticky color="#066BEE" line-height="2px"
                           @change="loadProductData">
                    <van-tab :key="item1.prodTag+item2.id" v-for="item2 in secondCateList" :title="item2.name">
                      <div class="product-list" v-for="(obj, j) in changeDataMap" :key="j" :style="{marginBottom:(size-1==j)?'100px':'0'}">
                        <div style="padding-left: 7px;padding-top: 15px;padding-bottom:5px;">
                          <div style="height: 18px;width: 3px;float: left;margin-top: 3px; background: #1987F5;"></div>
                          <span style="padding-left: 5px;color: black;font-weight: 500;">{{obj[0] | swtichName}}</span>
                        </div>
                        <van-list>
<!--
                              <van-cell v-for="(subItem,index) in obj[1]" :key="index" @click="gotoProductDetail(subItem)" role="button" :aria-labelledby="item.prodTag == '1' ? ['prodName' + index] : [ item.prodTag == '2' ? ['prodNameT' + index]:['prodNameG' + index]]">
-->
                            <van-cell v-for="(subItem,index) in obj[1]" :key="index" @click="gotoProductDetail(subItem)" role="button">
                             <template slot="title">
                                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                                            <van-image :src="subItem.image" width="67px" height="67px" radius="6px"/>
                                          <!-- :id="item.prodTag == '1' ? ['prodName' + index] : [ item.prodTag == '2' ? ['prodNameT' + index]:['prodNameG' + index]]" -->
                                            <div :id="item1.prodTag == '1' ? ['prodName' + index] : [ item1.prodTag == '2' ? ['prodNameT' + index]:['prodNameG' + index]]" aria-hidden="true" style="flex: 1; margin-left:12px; display: flex; flex-direction: column; align-items: start;">
                                                <div style="color: #4E4E4E; font-size: 16px; font-weight: bolder;">
                                                  {{subItem['prodName']}}
                                                </div>
                                                <div :style="`color: #666666; font-size: 14px; white-space: nowrap; width: ${windowWidth - 130}px; overflow: hidden; text-overflow:ellipsis;`">
                                                    {{subItem['prodDescribe']}}
                                                </div>
                                                <div style="color: #066BEE; font-size: 18px; font-weight: bolder;width:100%;display: flex;justify-content: space-between;align-items: center;">
                                                  <div>
                                                    {{`¥${subItem.price||'1'}`}}
                                                    <span style="color: #999999; font-size: 14px;">元起</span>
                                                  </div>
                                                  <van-icon id="rightArrow" name="arrow"></van-icon>
                                                </div>
                                            </div>

                                        </div>
                                    </template>
                                </van-cell>

                          </van-list>

                      </div>

                    </van-tab>

                </van-tabs>
              </van-tab>
            </van-tabs>
        </div>
        <div v-else>
          <van-tabs v-model="active" swipeable animated sticky color="#F1F8F2" line-height="2px"
                    @change="getProductListData" style="" class="first-cate">
            <van-tab v-for="item1 in list" :key="item1.name" :title="item1.name"
                     style="border-top: 1px solid #ebedf0;">
              <div class="product-list" v-for="(obj, j) in changeDataMap" :key="j" :style="{marginBottom:(size-1==j)?'100px':'0'}">
                <div style="padding-left: 7px;padding-top: 15px;padding-bottom:5px;">
                  <div style="height: 18px;width: 3px;float: left;margin-top: 3px; background: #1987F5;"></div>
                  <span style="padding-left: 5px;color: black;font-weight: 500;">{{obj[0] | swtichName}}</span>
                </div>
                 <van-list>
                <van-cell v-for="(subItem,index) in obj[1]" :key="index"
                          @click="gotoProductDetail(subItem)" role="button" :aria-labelledby="'prodNameYY' + index">
                        <template slot="title">
                              <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                                  <van-image :src="subItem.image" width="67px" height="67px" radius="6px"/>
                                  <div :id="'prodNameYY' + index" aria-hidden="true" style="flex: 1; margin-left:12px; display: flex; flex-direction: column; align-items: start;">
                                      <div style="color: #4E4E4E; font-size: 16px; font-weight: bolder;">
                                          {{subItem.prodName}}
                                      </div>
                                      <div :style="`color: #666666; font-size: 14px; white-space: nowrap; width: ${windowWidth - 130}px; overflow: hidden; text-overflow:ellipsis;`">
                                          {{subItem.prodDescribe}}
                                      </div>
                                      <div style="color: #066BEE; font-size: 18px; font-weight: bolder;width:100%;display: flex;justify-content: space-between;align-items: center;">
                                         <div>
                                           {{`¥${subItem.price||'1'}`}}<span
                                             style="color: #999999; font-size: 14px;">元起</span>
                                         </div>
                                        <van-icon  id="rightArrow2" name="arrow"></van-icon>
                                      </div>
                                  </div>

                              </div>
                        </template>
                </van-cell>
              </van-list>
              </div>
            </van-tab>
          </van-tabs>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Tab, Tabs, List, Cell, Icon, Image,Search,Swipe, SwipeItem,} from 'vant';
    import Cookies from 'js-cookie'
    import {wxChatShare} from '@/utils/wxShare'
    import config from "@/utils/config";
    import {sortMap} from "@/utils/commonUtils";

    Vue.use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image).use(Search).use(Swipe).use(SwipeItem);


    let prodMap = new Map([
      //公益人
      ['3', [{id: 0, name: '全部'},{id: 301, name: '子女'}, {id: 302, name: '自己及配偶'}, {id: 303, name: '父母'}, {id: 333, name: '体检'}]],
      //社区居民
      ['4',[{id: 0, name: '全部'},{id:401,name:'老人'},{id:411,name:'中青年'},{id:421,name:'少年儿童'},{id:431,name:'心智宝'},{id:441,name:'体检'}]],
      //公益组织
      ['5',[{id: 0, name: '全部'},{id:501,name: '意外险'},{id:502,name:'责任险'},{id:503,name:'救援险'},{id:504,name:'重疾险'},{id:505,name:'视力障碍'},{id:555,name:'体检'}]]
    ])

    export default {
        name: "product",
        data() {
            return {
                user: this.$store.state.user.user,
                windowWidth: window.outerWidth,
                type: Cookies.get('type'),
                active: 0,
                active1: 0,
                pageSize: 100,
                flag:true,
                flag1:true,
                searchValue:'',
                images: [],
                existsProdTwoCateList:[],//存在商品的二级分类
                list: Cookies.get('type') === '0' ? [
                    {title: '公益人', type: 0, page: 0, prodTag: '3',finished: false, loading: false, list: []},
                    {title: '社区居民', type: 0, page: 0, prodTag: '4', finished: false, loading: false, list: []},
                    {title: '公益组织', type: 0, page: 0, prodTag: '5', finished: false, loading: false, list:[]},
                ] : [
                    {id: 0, name: '全部',finished: false, loading: false, list: []},
                    {id: 301, name: '子女',finished: false, loading: false, list: []},
                    {id: 302, name: '自己及配偶', finished: false, loading: false,list: []},
                    {id: 303, name: '父母', finished: false, loading: false,list: []},
                    {id: 333, name: '体检',finished: false, loading: false, list: []}
                ],
                secondCateList:[],
                dataMap:new Map(),
                size:0,
                mapChangeTrucherCont:0,
                finished:false

            }
        },
        created() {
          this.settingShare()
          if (this.$route.query.shareId) {
            this.$axios.get("/love/viewShare", {params: {userId: this.$route.query.shareId}})
          }
          this.getBannerImage()

          this.getSecondCateCodeConfigData()


          let that = this
          setTimeout(function () {
            if (that.type == '0') {
              let curentSelProtag = that.$route.query.id ? that.$route.query.id : "0";
              let curIdx = 0;
              for (let n = 0, len = that.list.length; n < len; n++) {
                if (that.list[n].prodTag == curentSelProtag) {
                  curIdx = n
                }
              }
              that.active = curIdx
              that.initCate()
            }
          }, 50)

          setTimeout(function () {
            that.loadProductData()
          }, 300)


        },
        mounted() {
            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }

        },
        watch:{
          /* active(n,o){
              this.loadProductData()

            },
           active1(n,o){
            this.loadProductData(0)
          },*/
        },
        destroyed() {
            window.removeEventListener('popstate', this.goBack, false);
        },
        filters:{
          swtichName: (value) => {
            return config.dictMap.get(Number(value))
          }
        },
        computed: {
          changeDataMap() {
            let x = this.mapChangeTrucherCont //监听到参数的变化  并改变map

          /*  let newMap = new Map()
            this.dataMap.forEach((v, k) => {
              newMap.set(k, v)
            });
            return newMap;*/
            return sortMap(this.dataMap, true)
          }
        },
        methods: {
          async getSecondCateCodeConfigData() {
            await this.$axios.get("/product/two-cate-num").then(res => {
              this.existsProdTwoCateList = res.data;

             // this.list1 = this.list1.filter(f => (f.prodTag == '0' || this.twoCateList.includes(f.prodTag)))
            });
          },
          clickBanner(itm){
            if(itm['imageJumpUrl']){
              window.location.href = itm['imageJumpUrl']
            }
          },
          getBannerImage() {
            this.$axios.get("/image/shuffling", {params: {imageType: '8', imageBelong: this.type}}).then(res => {
              this.images = res.data;
            });
          },
          onSearch(){
            this.loadProductData()
          },
          async initCate(){

            let that = this
            const item = that.list[this.active]
            let firstCateTag = item['prodTag']
            setTimeout(function(){
              that.secondCateList = prodMap.get(firstCateTag).filter(f => (f.id===0 || that.existsProdTwoCateList.includes(f.id+"")))
            },50)


            this.active1 = 0
          },
            goBack() {
                this.$router.replace({path: '/'});
                //replace替换原路由，作用是避免回退死循环
            },
            settingShare() {
                let name = this.user.userName || this.user.loginName
                let title = ' 向您推荐益+普惠保险综合服务平台'
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: "【" + name + "】" + title, // 分享数据配置 主标题
                    desc: '研究倡导 | 金融教育 | 产品研发 | 公益金融', // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '/productList?shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                    imgUrl: this.type === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/ce397ee056b9b80366696712a728d9e0.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/5c9842d2c40425dc8bc21f69f0c7c6f2.png', // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                wxChatShare(param);
            },
            getProductListData() {
              if (this.type == '0'){
                this.initCate()
              }
              this.loadProductData()
            },
          loadProductData() {
            const item1 = this.list[this.active]
            let item2 = this.secondCateList[this.active1]

            let params = {type: Cookies.get('type'), page: 1, pageSize: this.pageSize};
            //益宝
            let allSecondIdArr = []
            let isYibao = false
            if(Cookies.get('type') === '0'){
              isYibao = true

              if (item1.prodTag) {
                params['prodTag'] = item1.prodTag
              }
              if (item2['id']) {
                params['prodTagTwo'] = item2['id']
              }
              if (this.searchValue) {
                params['keywords'] = this.searchValue
              }
              //当前一级分类下，所有二级分类
              allSecondIdArr = prodMap.get(item1.prodTag).filter(f => f.id !== 0).map(f => f.id)

            }else{
              //公益人
              params['prodTag'] = '3'
              //实际上为二级分类
              if (item1.id) {
                params['prodTagTwo'] = item1.id
              }

              //公益人分类下，所有二级分类
              allSecondIdArr = prodMap.get("3").filter(f => f.id !== 0).map(f => f.id)

            }




            this.dataMap.clear();
            this.$axios.get("/product/list", {params: params}).then(res => {
              let rows = res.data.rows;
              let cateId = isYibao?item2['id']:item1['id']
              this.buildMap(rows, allSecondIdArr, cateId)


              //心智宝
             /* if(this.type==='1'){
                item1.list = rows
                item1.loading = false
                item1.finished = true
              }
*/

            }).catch(err => {
              console.log("出错了。。")
            })



          },
          buildMap(rows, allSecondIdArr, cateId) {
            rows.forEach(info => {
              if (cateId) {
                let tmpList = this.dataMap.get(cateId)
                if (!tmpList) {
                  tmpList = []
                }
                tmpList.push(info)
                this.dataMap.set(cateId, tmpList)

              } else {
                //二级分类选择全部时，需要查询当前一级分类的所有二级分类。
                if (info['prodTagTwo']) {
                  info['prodTagTwo'].split(",").filter(f => allSecondIdArr.includes(Number(f))).forEach(prodTagTwo => {
                    let tmpList = this.dataMap.get(prodTagTwo)
                    if (!tmpList) {
                      tmpList = []
                    }
                    tmpList.push(info)
                    this.dataMap.set(prodTagTwo, tmpList)
                  })

                }
              }

            })


            this.size = this.dataMap.size
            this.mapChangeTrucherCont += 1
          },
            gotoProductDetail(item) {
                //add by cpgu 2023/01/15 begin
                if(item['isEnterCustDetailPage']){
                  this.$router.push({path: '/custProductDetail', query: {id: item.productId}})
                  return;
                }
                //end by cpgu

                //产品为特殊产品，需要直接跳转到外部链接
                if(item.prodShape ==='1' && item.jumpConnection){
                  window.location.href = item.jumpConnection
                  return;
                }

                if (item.prodShape === '1' || item.prodType === '1') {
                    this.$router.push({path: '/productDetail', query: {id: item.productId}})
                } else {
                    this.$axios.get("/jump/prodUrl", {
                        params: {
                            productId: item.productId,
                            shareId: Cookies.get('shareId')
                        }
                    }).then(res => {
                        window.location.href = res.data
                    });
                }
            },
        }
    }
</script>

<style scoped>
/deep/ .van-search .van-field__right-icon{
  color: #3894FF !important;
  font-weight: 500;
  font-size: 16px;
}
/deep/ .van-search__content{
  border: #999999 solid 1px !important;
  background: #FFFFFF !important;
}

.first-cate > /deep/ div>div>div>.van-tabs__nav{
    background: #F0F8FD;
}

.product-list{
  background: white;
  width: 95%;
  box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
  border-radius: 10px;
  margin-top: 20px;
  margin-left: 10px;
}

</style>
